<template>
  <div class="media-dialog" v-if="isVisible" v-loading="isBusy">
    <div class="media-dialog__header">
      <button @click="close" class="border-0 bg-transparent">
        <i class="fas fa-2x fa-times"></i>
      </button>
    </div>
    <div class="media-dialog__body text-left">
      <component v-bind:is="getComponent" @cancel="onCancel" @stored="onStored" :model="form"
                 :pending-message-index-url="pendingMessageIndexUrl"
                 :store-pending-message-url="storePendingMessageUrl"
                 :conversation-id="getConversationId"
      ></component>
    </div>
    <div class="media-dialog__footer text-center">

    </div>
  </div>
</template>

<script>
import ScheduleForm from './schedule-form';
import ScheduleList from './schedule-list';

export default {
  components: {
    'schedule-form': ScheduleForm,
    'schedule-list': ScheduleList,
  },

  props: {
    storePendingMessageUrl: String,
    pendingMessageIndexUrl: String,
  },

  data() {
    return {
      visible: false,
      isBusy: false,
      component: null,
      form: null,
      conversationId: null,
    };
  },

  computed: {
    /**
     * @return {boolean}
     */
    isVisible() {
      return this.visible;
    },

    /**
     * @return {String}
     */
    getComponent() {
      return this.component;
    },

    /**
     * @return {Number|null}
     */
    getConversationId() {
      return this.conversationId;
    },
  },

  methods: {
    /**
     * @param {Object} component
     * @param {Object} form
     * @param {Number} conversationId
     */
    show({component, form = null, conversationId = null}) {
      this.component = component;
      this.form = form;
      this.visible = true;
      this.conversationId = conversationId;
    },

    /**
     * @return {undefined}
     */
    close() {
      this.component = null;
      this.visible = false;
    },

    /**
     * @return {undefined}
     */
    onCancel() {
      this.close();
    },

    /**
     * @param {Object} message
     * @return {undefined}
     */
    onStored({message}) {
      _.isString(message) && this.$message.success(message);
      this.$emit('stored');
      this.component = 'schedule-list';
    },
  },

  created() {
    eventBus.$on('show-schedule-dialog', this.show);
  },

  beforeDestroy() {
    eventBus.$off('show-schedule-dialog', this.show);
  },
}
</script>

<style scoped>

</style>
